import { put, call, select, takeLatest, all, fork } from "redux-saga/effects";
import * as types from "./featuresTypes";
import * as totalDataTypes from "~/store/totalData/types";
import * as feeTypes from "~/store/fee/feeTypes";
import * as actions from "./featuresActions";
import * as loginActions from "~/store/login/actions";
import * as api from "./featuresAPIs";
import axios from "axios";
import history from "~/history";
import { FEATURE_TYPES } from "~/utils/constants";

function* requestAllFeatures() {
  try {
    yield put(actions.loadingAllFeatures());
    const partnerid = yield select(state => state.totalData.partnerId);
    const hospitalSelected = yield select(
      state => state.totalData.hospitalSelected
    );
    axios.defaults.headers.partnerid = partnerid;
    const response = yield call(api.requestAllFeatures);
    const { data } = response;

    if (response.status !== 200 || response.data.error_code)
      throw new Error("Lỗi server!");

    // page home: ko auto chọn
    // check đã chọn bv hay chưa
    // lấy những feature is actived
    if (hospitalSelected !== null) {
      const availableFeature = data.filter(o => o.status);
      if (availableFeature.length === 1) {
        yield put({
          type: types.SELECT_FEATURE,
          payload: availableFeature[0].type
        });
      } else {
        history.push(`${partnerid}/chon-hinh-thuc-dat-kham`);
      }
    }
    yield put(actions.requestAllFeaturesSuccess(data));
  } catch (error) {
    yield put(actions.requestAllFeaturesFail(error));
  }
}

function* watcherRequestAllFeatures() {
  yield takeLatest(types.REQUEST_ALL_FEATURES, requestAllFeatures);
}

// SELECT FEATURE
function* requestSelectFeature({ payload }) {
  const IsAuthenticated = yield select(state => state.user.IsAuthenticated);
  if (payload.includes("booking")) {
    const flow = payload.split(".")[1];
    yield put({ type: totalDataTypes.CHANGE_BOOKING_FLOW, flow });
    yield put({ type: totalDataTypes.GET_BOOKING_TREE });
  } else {
    switch (payload) {
      case FEATURE_TYPES.paymentFee: {
        history.push("/tim-ma-thanh-toan-vien-phi");
        break;
      }
      case FEATURE_TYPES.paymentFeeHistory: {
        if (!IsAuthenticated) {
          yield put(loginActions.redirectToMedproId());
        } else {
          yield put({ type: feeTypes.GET_HISTORY_PAYMENT });
        }
        break;
      }
      case FEATURE_TYPES.eInvoice: {
        yield history.push("/tra-cuu-hoa-don-dien-tu");
        break;
      }
      case FEATURE_TYPES.examResultSearch: {
        yield history.push("/tra-cuu-hoa-don-dien-tu");
        break;
      }
      case FEATURE_TYPES._eInvoice: {
        yield history.push("/tra-cuu-hoa-don-dien-tu");
        break;
      }
      case FEATURE_TYPES.khaiBaoYTe: {
        yield history.push("/khai-bao-y-te");
        break;
      }
      default: {
        return "";
      }
    }
  }
}

function* watcherSelectFeature() {
  yield takeLatest(types.SELECT_FEATURE, requestSelectFeature);
}

export default function* root() {
  yield all([fork(watcherRequestAllFeatures), fork(watcherSelectFeature)]);
}
